var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"font-size-65 text--disabled"},[_vm._v(" "+_vm._s(_vm.serverVersion)+" · "+_vm._s(_vm.clientVersion)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }